import { atom, RecoilState } from "recoil";
import { persistAtom } from "./persist";
import { ESupportedGames, IClipNode } from "MVVM/@types";

export enum Move {
  up,
  down,
}

type ProfileMontageSession = {
  clips: IClipNode[];
  game: ESupportedGames | null;
};

export const defaultState: ProfileMontageSession = { clips: [], game: null };
export const ProfileMontageSession: RecoilState<ProfileMontageSession> = atom({
  key: "ProfileMontageSession_v0.2",
  default: defaultState,
  effects_UNSTABLE: [persistAtom],
});

export const ShowUnavailableMessages = atom<boolean>({
  key: "ShowUnavailableMessages",
  default: false,
});

export const removeClip = (
  state: ProfileMontageSession,
  clip: IClipNode,
): ProfileMontageSession => {
  if (!clip.moment?.id) return state;
  const clips = [
    ...(state.clips || []).filter((c) => c.moment!.id !== clip.moment!.id),
  ];
  if (!clips.length) return defaultState;
  return {
    ...state,
    clips,
  };
};

export const addClip = (
  state: ProfileMontageSession,
  clip: IClipNode,
): ProfileMontageSession => {
  if (clip.type !== "STANDARD") return state;
  if (!clip.moment?.id) return state;

  if (state.clips.length === 10) return state;
  if (state.clips.some((c) => c.moment!.id === clip.moment!.id)) return state;

  const clips = [...(state.clips || []), clip];
  let { game } = state;
  if (!game) game = clip.game as ESupportedGames;
  return { clips, game };
};

export const moveClip = (
  state: ProfileMontageSession,
  clip: IClipNode,
  direction: Move,
): ProfileMontageSession => {
  const clips = [...state.clips];
  const index = clips.findIndex((c) => c.moment!.id === clip.moment!.id);
  console.log("moveClip", state, clip, direction, index);

  if (index === -1) return state;

  if (direction === Move.up && index > 0) {
    [clips[index - 1], clips[index]] = [clips[index], clips[index - 1]];
    return { ...state, clips };
  }
  if (direction === Move.down && index < clips.length - 1) {
    [clips[index], clips[index + 1]] = [clips[index + 1], clips[index]];
    return { ...state, clips };
  }
  return state;
};
